import {Alert, AlertColor, IconButton, Snackbar} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {useCallback} from 'react'
import {useAlerts} from './useAlerts'

export interface AlertCreateOptions {
  message: string
  timeout?: number
  color: AlertColor
}

export interface AlertData extends AlertCreateOptions {
  key: string
}

export const AlertContainer = () => {
  const {alerts, close} = useAlerts()

  const firstAlert = alerts[0]

  const handleClose = useCallback(() => {
    if (firstAlert) {
      close(firstAlert.key)
    }
  }, [close, firstAlert])

  if (!firstAlert) {
    return null
  }

  return (
    <Snackbar
      key={firstAlert.key}
      autoHideDuration={firstAlert.timeout}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      open
      onClose={handleClose}
    >
      <Alert severity={firstAlert.color} sx={{width: '100%'}}>
        {firstAlert.message}
        <IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
          <CloseIcon fontSize='small' />
        </IconButton>
      </Alert>
    </Snackbar>
  )
}
